var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4367 14.648C20.4258 12.7832 21.2707 11.3777 22.977 10.3414C22.0227 8.97422 20.5789 8.22227 18.6758 8.07734C16.8738 7.93516 14.9023 9.12734 14.1805 9.12734C13.4176 9.12734 11.673 8.12656 10.3004 8.12656C7.46758 8.17031 4.45703 10.3852 4.45703 14.8914C4.45703 16.223 4.70039 17.5984 5.18711 19.0148C5.83789 20.8797 8.18398 25.4488 10.6312 25.375C11.9109 25.3449 12.816 24.4672 14.4812 24.4672C16.0973 24.4672 16.934 25.375 18.3613 25.375C20.8305 25.3395 22.9523 21.1859 23.5703 19.3156C20.259 17.7543 20.4367 14.7438 20.4367 14.648ZM17.5629 6.3082C18.9492 4.66211 18.8234 3.16367 18.7824 2.625C17.5574 2.69609 16.141 3.45898 15.3344 4.39688C14.4457 5.40313 13.9234 6.64727 14.0355 8.05C15.359 8.15117 16.5676 7.47031 17.5629 6.3082Z",
    fill: "#F1F3F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteApple);
export default __webpack_public_path__ + "static/media/white-apple.92a027fa6fa286856c5b74107e4cc636.svg";
export { ForwardRef as ReactComponent };